import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const GraphingSelectionsReducer = () => [];

export const GraphingSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(GraphingSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(GraphingSelectionsReducer),
};
